import React, { useEffect } from 'react'

//Router dom
import { Route, Routes, useLocation, Navigate } from 'react-router-dom'

//MUI
import { createTheme, ThemeProvider } from '@mui/material'

//Components
import Header from './components/Header/Header';
import Index from './components/Index/Index';
import Footer from './components/Footer/Footer';
import Contact from './components/Contact/Contact';
import About from './components/About/About';
import ServicesComponent from './components/ServicesComponent/ServicesComponent';
// import Certifications from './components/Certifications/Certifications';
import AvisoPrivacidad from './components/Avisos/AvisoPrivacidad';
import TerminosCondiciones from './components/Avisos/TerminosCondiciones';
import PresentationComponent from './components/Presentation/PresentationComponent';

const theme = createTheme({
  typography: {
    fontFamily: 'Lato',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1536,
    },
  },
});

function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

const App = () => {

  useScrollToTop();

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <Routes>
        <Route path='/' element={<Index />}></Route>
        <Route path='/nosotros' element={<About />}></Route>
        <Route path='/servicios' element={<ServicesComponent />}></Route>
        {/* <Route path='/certificaciones' element={<Certifications />}></Route> */}
        <Route path='/contacto' element={<Contact />}></Route>
        <Route path='/aviso-de-privacidad' element={<AvisoPrivacidad />}></Route>
        <Route path='/terminos-y-condiciones' element={<TerminosCondiciones />}></Route>
        <Route path='/presentacion' element={<PresentationComponent />}></Route>
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
      <Footer />
    </ThemeProvider>
  )
}

export default App